<template>
  <el-container style="height: 100vh">
    <el-aside width="200px" style="background: #001529">
      <div class="logo">管理后台</div>
      <el-menu
        :default-active="activeMenu"
        background-color="#001529"
        text-color="#c9d1d9"
        active-text-color="#409eff"
        router
      >
        <el-menu-item index="/users"><i class="el-icon-user"></i> 用户管理</el-menu-item>
        <el-menu-item index="/point-records"><i class="el-icon-tickets"></i> 积分记录</el-menu-item>
        <el-menu-item index="/drama-unlocks"><i class="el-icon-video-play"></i> 短剧解锁记录</el-menu-item>
        <el-menu-item index="/settings"><i class="el-icon-setting"></i> 系统设置</el-menu-item>
        <el-menu-item index="/tasks"><i class="el-icon-date"></i> 每日任务管理</el-menu-item>
        <el-menu-item index="/task-stats"><i class="el-icon-s-data"></i> 任务完成情况</el-menu-item>
        <el-menu-item index="/open-clients"><i class="el-icon-connection"></i> 第三方接入</el-menu-item>
        <el-menu-item index="/app-versions"><i class="el-icon-refresh"></i> 版本管理</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #fff;
          border-bottom: 1px solid #eee;
        "
      >
        <span style="font-size: 16px; font-weight: 500">{{ $route.meta.title }}</span>
        <el-button size="small" @click="logout">退出登录</el-button>
      </el-header>
      <el-main style="background: #f5f5f5">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "Layout",
  computed: {
    // 用户详情页 /users/xxx 也高亮“用户管理”
    activeMenu() {
      return this.$route.path.startsWith("/users") ? "/users" : this.$route.path;
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("admin_token");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.logo {
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  font-weight: bold;
}
</style>
